import { __awaiter } from "tslib";
import { HD } from '@bsv/sdk';
import { AuthHeader, setSignature } from './authentication';
import { ErrorNoAdminKey, ErrorResponse } from './errors';
export class HttpClient {
    constructor(logger, url, key, adminKey) {
        if (key != null) {
            if (typeof key === 'string') {
                //only xPub can be a string
                this.xPubString = key;
            }
            else {
                this.signingKey = key;
            }
        }
        if (adminKey) {
            this.adminKey = new HD().fromString(adminKey);
        }
        this.logger = logger;
        this.baseUrl = url.endsWith('/') ? url : url + '/'; //make sure the url ends with a '/'
    }
    adminRequest(path_1) {
        return __awaiter(this, arguments, void 0, function* (path, method = 'GET', payload = null) {
            if (!this.hasAdminKey()) {
                throw new ErrorNoAdminKey();
            }
            this.logger.debug('Making request as admin on', method, path);
            return this.makeRequest(path, method, payload, this.adminKey);
        });
    }
    request(path_1) {
        return __awaiter(this, arguments, void 0, function* (path, method = 'GET', payload = null) {
            this.logger.debug('Making request on', method, path);
            return this.makeRequest(path, method, payload, this.signingKey);
        });
    }
    hasAdminKey() {
        return this.adminKey != null;
    }
    makeRequest(path, method, payload, currentSigningKey) {
        return __awaiter(this, void 0, void 0, function* () {
            const json = payload ? JSON.stringify(payload) : null;
            let headers = { 'content-type': 'application/json' };
            if (currentSigningKey != null) {
                headers = setSignature(headers, currentSigningKey, json || '');
            }
            else if (this.xPubString) {
                headers[AuthHeader] = this.xPubString;
            }
            const res = yield globalThis.fetch(this.prepareUrl(path), {
                method,
                headers,
                body: json,
            });
            if (res.ok) {
                const contentType = res.headers.get('Content-Type');
                if (contentType && contentType.includes('application/json')) {
                    return res.json();
                }
                return res.text();
            }
            else {
                const rawContent = yield res.text();
                throw new ErrorResponse(this.logger, res, rawContent);
            }
        });
    }
    prepareUrl(path) {
        path = path.startsWith('/') ? path.substring(1) : path;
        return this.baseUrl + path;
    }
}
